import { Message } from "./ChatService.types";

export const STREAM_API_KEY = process.env.REACT_APP_STREAMIO_KEY!;

export const DUMMY_MESSAGES: Message[] = [];
